export enum BLOCKCHAIN_KEY {
  ETHEREUM = 'ETHEREUM',
  POLKADOT = 'POLKADOT',
}
